/**
 * The app's single TanStack Query client. Hooks pass it explicitly
 * (`useQuery(opts, queryClient)`) so they work with or without a provider in
 * the tree, and tests can clear it between cases.
 */
import { QueryClient } from "@tanstack/react-query";

import { queryRetryDelay, shouldRetryQuery } from "@/api/retryPolicy";

export const DAY_MS = 24 * 60 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: DAY_MS,
      refetchOnWindowFocus: true,
      retry: shouldRetryQuery,
      retryDelay: queryRetryDelay
    }
  }
});
